import React, { useState, useEffect } from 'react';
import {
  Typography,
  Box,
  IconButton,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AppointmentCalendar from './AppointmentCalendar';
import { getServices } from '../../services/api';
import { Service } from '../../types';
import { useLanguage } from '../../contexts/LanguageContext';

interface DateTimeSelectionProps {
  barberId: number;
  serviceId: number;
  onBack: () => void;
  onTimeSelect?: (date: string, time: string) => void;
}

const DateTimeSelection: React.FC<DateTimeSelectionProps> = ({
  barberId,
  serviceId,
  onBack,
  onTimeSelect = () => {}
}) => {
  const { t } = useLanguage();
  const [service, setService] = useState<Service | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchService = async () => {
      try {
        const services = await getServices();
        const selectedService = services.find(s => s.id === serviceId);
        if (selectedService) {
          setService(selectedService);
        }
      } catch (error) {
        console.error('Error fetching service:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchService();
  }, [serviceId]);

  if (loading || !service) {
    return <Typography>{t('app.loading')}</Typography>;
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ mb: 3, display: 'flex', alignItems: 'center' }}>
        <IconButton 
          onClick={onBack} 
          sx={{ mr: 2 }}
          aria-label={t('button.back')}
        >
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h5">{t('datetime.selectDate')}</Typography>
      </Box>
      
      <AppointmentCalendar
        barberId={barberId}
        service={service}
        onTimeSelect={onTimeSelect}
      />
    </Box>
  );
};

export default DateTimeSelection; 